export class DefinitionDroitsBC {
    public static TYPE = "BC";
    public static ADMIN = 10;
    public static VOIR = 0;
    public static CREER = 1;
    public static LIVRER = 2;
    public static VALS0 = 3; // Validation CA1
    public static VALS1 = 4; // Validation Fin1
    public static VALS2 = 5; // Validation Fin2
    public static VALS3 = 6;
    public static VALS4 = 7;
}

export class DefinitionDroitsInterface {
    public static TYPE = "INTERFACE";
    public static IMPORTBCAVALID = 2;
    //public static IMPORTBCNONPROV = 3;
    public static IMPORTBCPROV = 4;
    public static INTERFACESAGE = 5;
}

export class DefinitionDroitsAdmin {
    public static TYPE = "ADMIN";
    public static USERSMANAGER = 1;
    public static REPOSITORIESMANAGES = 2;
}